// APP LANGUAGE CONFIG
export const nepaliLanguage = {
  isNepali: true,
  key: {
    home: "गृह",
    contact: "सम्पर्क",
    whoweare: "हाम्रो बारेमा",
    ourteam: "हाम्रो समूह",
    currentResearch: "अनुसन्धान",
    research: "अनुसन्धान",
    researchPrograms: "अनुसन्धान कार्यक्रमहरू",
    new: "हाल भैरहेको अनुसन्धान",
    old: "पुरा भएको अध्ययन",
    events: "कार्यक्रम",
    recentEvents: "भर्खरका कार्यक्रमहरू",
    moreEvents: "थप कार्यक्रमहरू",
    outputs: "परिणामहरू",
    publication: "प्रकाशन",
    newsletter: "समाचार पत्र",
    news: "समाचार",
    openinghours: "खुल्ने समय",
    openingtime: "बिहान ९ बजे देखि साँझ ४ बजे सम्म",
    telephone: "+९७७ ९८६५५५८७५९",
    introduction: "परिचय",
    readmore: "थप पढ्नुहोस्",
    send: "पठाउनुहोस्",
    imagegallery: "तस्बिरहरु",
    seeall: "सबै हेर्नुहोस्",
    view: "हेर्नुहोस्",
    download: "डाउनलोड गर्नुहोस्",
    article: "लेख",
    mediaOutput: "प्रस्तुतीकरण",
    notfound: "404 पृष्ठ छैन",
    notfounddesc: "तपाईंले अनुरोध गर्नुभएको पृष्ठ फेला परेन",
    scrolltotop: "शीर्षमा स्क्रोल गर्नुहोस्",
    whatwedo: `हामी के गर्छौ?`,
    collaborators: "सहयोगीहरु",
    newsupdate: "समाचार अपडेट",
    disclaimer: "अस्वीकरण",
    quickLinks: "द्रुत लिंक",
    nirc: "एनआईआरसी",
    headerTeamDesc:
      "नेपाल इन्जरी अनुसन्धान केन्द्रमा विविध विधामा दक्षता हासिल गरेका अनुसन्धानकर्ताहरुको समूह रहेको छ जसको कार्यक्षमताले नेपालमा इन्जरी रोकथाममा टेवा पुर्याउदछ।",
    allProgramme: "सबै अनुसन्धान कार्यक्रम",
    homepage: {
      introduction:
        "नेपाल इन्जरी रिसर्च सेन्टर (NIRC) २०१७ मा स्थापना गरिएको थियो र यस सस्था युके न्याशनल इन्स्टिट्युट फर हेल्थ एन्ड केयर रिसर्च (NIHR) को आर्थिक सहयोगमा ग्लोबल हेल्थ अनुसन्धान कार्यक्रम भैरहेकोछ ।",
      firsth1: "नेपाल  इन्जरी अनुसन्धान केन्द्रमा",
      secondh1: "स्वागत छ",
      introductionfull: {
        para1: `नेपाल इन्जरी रिसर्च सेन्टर (NIRC) २०१७ मा स्थापना गरिएको थियो र यस सस्था युके न्याशनल इन्स्टिट्युट फर हेल्थ एन्ड केयर रिसर्च (NIHR) को आर्थिक सहयोगमा ग्लोबल हेल्थ अनुसन्धान कार्यक्रम भैरहेकोछ। काठमाडौं मेडिकल कलेज (KMC) र युनिभर्सिटी अफ द वेस्ट अफ इंग्ल्यान्ड, ब्रिस्टल (UWE) युके बीचको साझेदारी स्थापना गरिएको छ। यस साझेदारीको उद्देश्य नेपालमा इपिडेमियोलोजीलाई राम्रो रूपमा समझ्न, चोटपटक घटनाहरू रोक्नका लागि  नीति  प्रदान गर्न र चोटपटकहरूको पहिलो प्रतिक्रिया सुधार्नका लागि अनुसन्धान क्षमताको विकास गर्न थियो। NIRC काठमाडौं मेडिकल कलेज दुवाकोट क्याम्पसको समुदाय चिकित्सा विभागमा आधारित छ। हाम्रो प्राथमिक आर्थिक सहयोगका दौरान सहकारीहरूमा मध्यान्तर मातृ र शिशु अनुसन्धान क्रियाकलाप (MIRA), नेपाल रेड क्रस सोसाइटी, स्वतन्त्रता अभियान, सेफ क्रसिङ्स, सेन्टर फर इन्जरी प्रिभेन्सन रिसर्च बांग्लादेश, र युनिभर्सिटी अफ ब्रिस्टल, युके थिए।`,
        para2: `२०२२ मा NIRC नेपाल ग्लोबल हेल्थ रिसर्च कार्यक्रमबाट मुख्य आर्थिक सहयोग प्राप्त गरेको थियो, जसले तिनीहरूको स्वास्थ्य नीति र प्रणाली अनुसन्ध कोष योजनाबाट थियो। २०२२ देखि २०२६ सम्म हामी सडक सुरक्षा गुणस्तर बनाउँदै गइरहेका छौं (नेपालमा सडक धुर्घतना रोकथाम र न्यूनीकरण गर्नका लागि सुरक्षित प्रणालीको दृष्टिकोण, सेफट्रिप नेपाल)। यस कोष  सहयोग गरेका संगठनहरूमा MIRA र सेफ एण्ड सस्टेनेबल ट्राभल नेपाल (SSTN) पनि संग्लग्न छन्।`,
      },
    },
    introductionPage: {
      whyisnirc: "इन्जुरी अनुसन्धान सेन्टरको आवश्यकता किन पर्छ ?",
      whynircdesc: {
        para1: `'चोटहरू' शब्दले बाह्य एजेन्ट वा बलबाट शरीरमा हुने कुनै पनि क्षति समावेश गर्दछ। यसमा घाउ, भाँचिएको वा जलेको जस्तो आघात पर्छन् जसले शरीरमा देखिने क्षति पुर्‍याउन सक्छ, तर यो पनि समावेश गर्दछ
        शरीरको बाहिरी भाग अक्षुण्ण देखिन्छ तर क्षति आन्तरिक भएको ठाउँमा विषाक्तता, निसासस वा डुबेर। चोटहरू विशेष परिस्थितिहरूको अनुमानित परिणाम हुन्। यसले चोटलाई विश्वको सबैभन्दा रोकथाम गर्न सकिने सार्वजनिक स्वास्थ्य समस्याहरू मध्ये एक बनाउँछ।`,
        para2: `विश्वको एक तिहाइ बिरामी र चोटपटकका कारण हुने मृत्यु दक्षिण पूर्व एसिया क्षेत्रका ११ देशमा हुने गरेको छ । नेपालमा चोटपटकको दर उच्च छ । सन् २०१५ मा भूकम्पमा परी करिब ९ हजारको ज्यान गएको थियो भने बढी घाइते भएका थिए
        22000 मान्छे। विश्वव्यापी रूपमा, सडक ट्राफिक चोटहरू 2030 सम्म मृत्युको 8 औं बाट 5 औं प्रमुख कारण हुने अनुमान गरिएको छ, जसमा अधिकांश निम्न र मध्यम आय भएका देशहरूमा हुने गर्दछ। पछिल्लो दशकमा नेपालमा सडक निर्माणको ठूलो कार्यक्रम देखिएको छ
        विगत ४ वर्षमा ८००७८ किलोमिटर सडक निर्माण र सवारी साधनको संख्या ८०००० भन्दा बढीले बढेको छ । धेरै नयाँ सडकहरूमा प्रमाणित सुरक्षा सुविधाहरू छैनन् र कमजोर मर्मत गरिएको छ। नेपालमा सडक सुरक्षाका लागि समन्वय र वित्तिय नेतृत्व छैन र सीमित छ
        ट्राफिक सुरक्षा कानूनको कार्यान्वयनको लागि क्षमता। सडक ट्राफिक चोट र मृत्यु बढ्दै गएको छ तर कुनै चोट निगरानी बिना, बलियो मृत्यु दर्ता वा पूर्ण ट्राफिक प्रहरी डाटा प्रणाली बिना, वास्तविक संख्या अज्ञात छ। घरपरिवार सर्वेक्षण
        र अस्पतालको तथ्याङ्कले घरमा हुने चोटहरू (जस्तै, खसेको, जलेको, विषाक्तता), पेशागत र जनावरको चोटपटक र आत्म-हानि महत्त्वपूर्ण छन् तर वास्तविक अनुमानहरू अस्पष्ट छन् भनी सुझाव दिन्छ। चोटहरूको आधारभूत बोझको स्पष्ट अनुमान बिना यो जान्न गाह्रो छ कि छैन
        चोटपटक लाग्न नदिनका कार्यक्रमहरू काम गरिरहेका छन् । थप रूपमा, त्यहाँ आपतकालीन सेवाहरूको विकास र समन्वय सीमित छ। फलस्वरूप, घाइतेहरूले घण्टौंसम्म आफ्नो चोटपटकको स्थिरता बिना नजिकैको अस्पतालमा पुग्न सक्छन्, र पीडित हुन सक्छन्।
        घटनास्थलमा प्राथमिक उपचार उपलब्ध भएको भए भन्दा कम परिणामहरू। यो अवस्था परिवर्तन हुन सक्छ। अनुसन्धानको लागि क्षमता र क्षमता सुदृढ गर्ने कार्यक्रम मार्फत, र जनता, सरोकारवाला र निर्णय निर्माताहरूसँग संलग्नता मार्फत, हामी सक्षम हुनेछौं।
        समस्याको मात्रा राम्रोसँग बुझ्न र यसलाई समाधान गर्न के गर्न सकिन्छ ।`,
      },
      howfunded: "नेपाल चोटपटक अनुसन्धान केन्द्रलाई कसरी वित्त पोषित गरिन्छ?",
      howfundedDesc:
        "हामी बेलायत सरकार द्वारा अनुदान पुरस्कार को एक श्रृंखला को माध्यम द्वारा वित्त पोषित छौँ",
      howfundedp1:
        "१) राष्ट्रिय स्वास्थ्य अनुसन्धान संस्थान, ग्लोबल हेल्थ रिसर्च प्रोग्राम £२.२८ मी जुलाई २०१७ - जून २०२१",
      howfundedp2:
        "२) राष्ट्रिय स्वास्थ्य अनुसंधान संस्थान, ग्लोबल हेल्थ स्वास्थ्य नीति र प्रणाली अनुसन्धान विकास कार्यक्रम पुरस्कार £७९,४८७ मार्च २०२० - मे २०२१।",
      howfundedp3:
        " ३) युनिवार्सिटी वेस्ट अफ इग्ल्यान्ड, ग्लोबल च्याल्लेन्ज अनुसंधान कोष किऊ आर पुरस्कार £२०७,०००    अगस्त २०१ ८- जुलाई २०२१।",
    },
    contactpage: {
      writetous: "हामीलाई लेख्नुहोस् यदि तपाईंसँग प्रश्नहरू छन् भने",
      name: "नाम",
      namePlaceholder: "तपाइँको पुरा नाम",
      phone: "फोन नम्बर",
      phonePlaceholder: "तपाइँको फोन नम्बर",
      email: "ईमेल",
      emailPlaceholder: "तपाइँको इ-मेल ठेगाना",
      subject: "विषय",
      subjectPlaceholder: "विषय",
      message: "सन्देश",
      messagePlaceholder: "सन्देश...",
      send: "पठाउनुहोस्",
      fulladdress:
        "नेपाल  इन्जरी अनुसन्धान केन्द्र(एनआईआरसी), सामुदायिक चिकित्सा विभाग, काठमाडौं मेडिकल कलेज (के.यम.सी.)",
      pobox: "पोष्ट बक्स २१२६६, दुवाकोट, भक्तपुर, नेपाल",
      telephone: "+९७७ ९८६५५५८७५९",
      emailaddress: "nirc@kmc.edu.np",
      address1: "नेपाल  इन्जरी अनुसन्धान केन्द्र(एनआईआरसी),",
      address2: "सामुदायिक चिकित्सा विभाग,",
      address3: "काठमाडौं मेडिकल कलेज (के.यम.सी.),",
      address4: "पोष्ट बक्स २१२६६, दुवाकोट, भक्तपुर, नेपाल",
    },
    researchDetail: {
      projectTitle: "परियोजना शिर्षक",
      background: "पृष्ठभूमिः",
      projectAim: "परियोजनाको उद्धेश्य",
      methods: "विधीहरु",
      impact: "अपेक्षित प्रभाव",
      team: "अध्ययन टोली",
      fullTextArticle: "अध्ययनको विस्तृत विवरण यहाँ उपलब्ध छ",
    },

    footer: {
      footerDesc:
        "नेपाल इन्जरी रिसर्च सेन्टर (NIRC) २०१७ मा युके न्याशनल इन्स्टिट्युट फर हेल्थ एन्ड केयर रिसर्च (NIHR) ग्लोबल हेल्थ रिसर्च प्रोग्रामबाट आएको आर्थिक सहयोगले स्थापना गरिएको थियो। यस सस्था काठमाडौं मेडिकल कलेज (KMC) र युनिभर्सिटी अफ द वेस्ट अफ इंग्ल्यान्ड, ब्रिस्टल (UWE) युके बीच एक साझेदारी पनि सिर्जना गरेको थियो। साझेदारीको उद्देश्य नेपालमा इपिडेमियोलोजीलाई गुणस्तर बिकाश गर्नु पनि हो, अनुसन्धान क्षमता बिकाश गर्न र इन्जरीहरूको प्रतिवन्धन र इन्जरीहरूमा पहिलो प्रतिक्रिया सुधार्नका लागि थियो।",
    },
    nodata: "डेटा उपलब्ध छैन",
  },
};

export const englishLanguage = {
  isNepali: false,
  key: {
    home: "Home",
    contact: "Contact Us",
    whoweare: "Who We Are",
    ourteam: "Our Team",
    currentResearch: "Research",
    research: "Research",
    researchPrograms: "Research Programme",
    new: "On-going Research",
    old: "Completed Study",
    events: "Events",
    recentEvents: "Recent Events",
    moreEvents: "More Events",
    outputs: "Outputs",
    publication: "Publications",
    newsletter: "Newsletter",
    news: "News",
    openinghours: "Opening hours",
    openingtime: "9AM to 4PM",
    telephone: "+977 9865558759",
    introduction: "Introduction",
    readmore: "Read More",
    send: "Send",
    imagegallery: "Image Gallery",
    seeall: "See All",
    view: "View",
    download: "Download",
    article: "Article",
    mediaOutput: "Presentations",
    notfound: "404 Page Not Found",
    notfounddesc: "The page you requested not found",
    scrolltotop: "Scroll To Top",
    whatwedo: `What We Do?`,
    collaborators: "Collaborators",
    newsupdate: "News Update",
    disclaimer: "DISCLAIMER",
    quickLinks: "Quick Links",
    nirc: "NIRC",
    allProgramme: "All Research Programme",
    headerTeamDesc:
      "Nepal Injury Research Centre has a strong multidisciplinary team who come from various academic backgrounds and are using their varied skillset to contribute to the field of Injury Prevention in Nepal.",
    homepage: {
      introduction: `The Nepal Injury Research Centre (NIRC) was established in 2017 with funding from the UK National Institute for Health and Care Research (NIHR) Global Health Research Programme.`,
      firsth1: "Welcome to",
      secondh1: "Nepal Injury Research Centre (NIRC)",
      introductionfull: {
        para1: `The Nepal Injury Research Centre (NIRC) was established in 2017 with funding from the UK National Institute for Health and Care Research (NIHR) Global Health Research Programme. A partnership was created between Kathmandu Medical College (KMC) and the University of the West of England, Bristol (UWE) in the UK. The aim of the partnership was to generate research capacity and to better understand the epidemiology of injuries in Nepal, providing evidence to prevent injury events and improve the first response to injuries. The NIRC is based within the Department of Community Medicine, at Kathmandu Medical College Duwakot Campus. During our initial funding collaborators included Mother and Infant Research Activities (MIRA), the Nepal Red Cross Society, Swatantrata Abhiyan, Safe Crossings, the Centre for injury Prevention Research Bangladesh, and the University of Bristol, UK.`,
        para2: ` In 2022 the NIRC received further core funding from the NIHR Global Health Research Programme, through their Health Policy and Systems Research award scheme. Between 2022 and 2026 we will be focussing on improving road safety (A safe systems approach to enabling traffic injury prevention in Nepal, SafeTrip Nepal). Collaborators on this award include MIRA and Safe and Sustainable Travel Nepal (SSTN).`,
      },
    },
    introductionPage: {
      whyisnirc: "Why do we need an injury research centre?",
      whynircdesc: {
        para1: `The term ‘injuries’ includes any damage to the body caused by an external agent or force. This includes trauma such as wounds, fractures or burns that might leave visible damage to the body, but also includes
        poisoning, suffocation, or drowning where the outside of the body looks intact but the damage is internal. Injuries are the predictable outcome of particular circumstances. This makes injury one of the world’s most preventable public health problems.`,
        para2: `One third of the world’s morbidity and mortality due to injuries occur in the 11 countries of the South East Asia Region. Nepal has high rates of injury. In 2015, earthquakes killed almost 9000 and injured over
        22000 people. Globally, road traffic injuries are projected to rise from the 8th to the 5th leading cause of death by 2030, with the majority occurring in low- and middle-income countries. A huge road building programme in Nepal over the last decade has seen
        80078km of roads built and vehicle numbers increased by over 800000 in the last 4 years. Many new roads do not have proven safety features and are poorly maintained. Nepal does not have a coordinated and funded leadership for road safety and there is limited
        capacity for enforcement of traffic safety legislation. Road traffic injuries and deaths are increasing but without any injury surveillance, robust death registration or complete traffic police data systems, the true numbers are unknown. Household surveys
        and hospital data suggest that home injuries (e.g. falls, burns, poisoning), occupational and animal injuries and self-harm are significant but true estimates are unclear. Without clear estimates of the baseline burden of injuries it is difficult to know if
        programmes to prevent injuries are working. In addition, there is limited development and coordination of emergency services. Consequently, injured people may travel for hours to the nearest hospital without any stabilisation of their injuries, and may suffer
        poorer outcomes than if first aid at the scene had been available. This situation can change. Through a programme of strengthening capacity and capability for research, and through engagement with the public, stakeholders and decision makers, we will be able
        to better understand the scale of the problem and what can be done to tackle it.`,
      },
      howfunded: "How is the Nepal Injury Research Centre funded?",
      howfundedDesc:
        "We are funded by the UK Government through a series of grant awards",
      howfundedp1: `1) The National Institute of Health Research, Global Health Research Programme. £2.28m. July 2017 – June 2021`,
      howfundedp2:
        "2) The National Institute for Health Research Global Health Policy and Systems Research Programme Development Award. £79, 487. March 2020-May 2021. ",
      howfundedp3:
        "3) University of the West of England, Global Challenges Research Fund QR award. £207,000. August 2018- July 2021.",
    },

    contactpage: {
      writetous: "Write to Us If You Have Questions",
      name: "Name",
      namePlaceholder: "Your Full Name",
      phone: "Phone",
      phonePlaceholder: "Your Phone Number",
      email: "Email",
      emailPlaceholder: "Your Email Address",
      subject: "Subject",
      subjectPlaceholder: "Subject",
      message: "Message",
      messagePlaceholder: "Message...",
      send: "Send",
      fulladdress:
        "Nepal Injury Research Centre (NIRC), Department of Community Medicine, Kathmandu Medical College (KMC)",
      pobox: "P O Box 21266, Duwakot, Bhaktapur, Nepal",
      telephone: "+977 9865558759",
      emailaddress: "nirc@kmc.edu.np",
      address1: "Nepal Injury Research Centre (NIRC),",
      address2: "Department of Community Medicine,",
      address3: "Kathmandu Medical College (KMC),",
      address4: "P O Box 21266, Duwakot, Bhaktapur, Nepal",
    },
    researchDetail: {
      projectTitle: "Project Title",
      background: "Background",
      projectAim: "Project Aim",
      methods: "Methods",
      impact: "Anticipated Impact",
      team: "Study Team",
      fullTextArticle: "Full text article available at",
    },

    footer: {
      footerDesc:
        "The Nepal Injury Research Centre (NIRC) was established in 2017 with funding from the UK National Institute for Health and Care Research (NIHR) Global Health Research Programme. A partnership was created between Kathmandu Medical College (KMC) and the University of the West of England, Bristol (UWE) in the UK. The aim of the partnership was to generate research capacity and to better understand the epidemiology of injuries in Nepal, providing evidence to prevent injury events and improve the first response to injuries.",
    },
    nodata: "No Data Available",
  },
};

export const LANGUAGE_TYPE = {
  np: "nepali",
  en: "english",
};

// पृष्ठ
